var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconLogout(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 28 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.334 24H1.998V1.333h15.336a.666.666 0 000-1.333H1.998C1.263 0 .667.597.667 1.333V24c0 .736.596 1.333 1.331 1.333h15.336a.666.666 0 000-1.333zm10-11.292L21.68 6.869a.656.656 0 00-.473-.202c-.37 0-.67.31-.67.691a.7.7 0 00.196.489l4 4.131h-15.4a.678.678 0 00-.666.689c0 .38.298.688.666.688h15.44l-4 4.131a.7.7 0 00-.196.49c0 .38.3.69.67.69a.655.655 0 00.473-.202l4.707-4.86.906-.896z",
    fill: "#424242"
  })));
}
export default SvgIconLogout;